import React from 'react';
import PropTypes from 'prop-types';

const FieldLabel = ({ label, name }) => (
    <label htmlFor={name} className={'d-block'}>
        {label}
    </label>
);

FieldLabel.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
};

FieldLabel.defaultProps = {
    label: '',
    name: '',
};

export default FieldLabel;
